import React, { useRef } from 'react';
import { addDocumentListener, addWindowListener, getEventPosition, } from 'app/utils/events';
import { call } from 'app/utils/function';
class WatermarkHoverWatcher {
    constructor(state = {
        hovered: false,
        bounds: undefined,
    }) {
        Object.defineProperty(this, "state", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: state
        });
        Object.defineProperty(this, "subscribe", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (onStoreChange) => {
                const handler = (evt) => {
                    const isWatermarkHidden = configGet('hideWatermarkDuringRollout', false);
                    const el = !isWatermarkHidden
                        ? document.querySelector('.project-watermark__image')
                        : null;
                    let pointerHovers = false;
                    if (el) {
                        const position = getEventPosition(evt, 'client');
                        const bounds = el.getBoundingClientRect();
                        pointerHovers =
                            position.x >= bounds.left &&
                                position.x <= bounds.right &&
                                position.y >= bounds.top &&
                                position.y <= bounds.bottom;
                        this.state.bounds = {
                            x: bounds.x,
                            y: bounds.y,
                            width: bounds.width,
                            height: bounds.height,
                        };
                    }
                    if (pointerHovers === this.state.hovered) {
                        return;
                    }
                    this.state = Object.assign(Object.assign({}, this.state), { hovered: pointerHovers });
                    onStoreChange();
                };
                const deactivate = () => {
                    if (!this.state.hovered) {
                        return;
                    }
                    this.state = Object.assign(Object.assign({}, this.state), { hovered: false });
                    onStoreChange();
                };
                const disposers = [
                    addDocumentListener('pointermove', handler),
                    addDocumentListener('visibilitychange', deactivate),
                    addWindowListener('resizer', deactivate),
                    addWindowListener('blur', deactivate),
                ];
                return () => {
                    disposers.forEach(disposer => call(disposer));
                };
            }
        });
        Object.defineProperty(this, "getSnapshot", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: () => this.state
        });
    }
}
export function useWatermarkInfo() {
    const watcher = useRef(new WatermarkHoverWatcher());
    const data = React.useSyncExternalStore(watcher.current.subscribe, watcher.current.getSnapshot);
    return data;
}
